import { takeLatest, takeEvery } from 'redux-saga/effects';
import { post, put } from '../../utils/request';

import {
  fetchCustomersRoutine,
  fetchCustomerRoutine,
  saveCustomerRoutine,
  removeCustomerRoutine,
  saveCustomerAddressRoutine,
} from '../routines';

import { getAccountPath } from '../../utils/firebase';
import { fetchSaga, saveSaga, removeSaga, buildFilterQuery } from './helper';

function* watchFetchCustomersSaga() {
  yield takeLatest(fetchCustomersRoutine.TRIGGER, fetchSaga(fetchCustomersRoutine, (payload) => getAccountPath('customers') + '?' + buildFilterQuery(payload)));
}

function* watchFetchCustomerSaga() {
  yield takeLatest(fetchCustomerRoutine.TRIGGER, fetchSaga(fetchCustomerRoutine, (payload) => getAccountPath('customers', payload.id)));
}

function* watchSaveCustomerSaga() {
  yield takeLatest(saveCustomerRoutine.TRIGGER, saveSaga(saveCustomerRoutine, (payload) => getAccountPath('customers', payload.values.get('id')), (payload) => payload.values.get('id') ? put : post, (payload) => payload.values));
}

function* watchRemoveCustomerSaga() {
  yield takeEvery(removeCustomerRoutine.TRIGGER, removeSaga(removeCustomerRoutine, (payload) => getAccountPath('customers', payload.id)));
}

function* watchSaveCustomerAddressSaga() {
  yield takeLatest(saveCustomerAddressRoutine.TRIGGER, saveSaga(saveCustomerAddressRoutine, (payload) => getAccountPath(`customers/${payload.customer.get('id')}/addresses`, payload.address.id), (payload) => payload.address.id ? put : post, (payload) => payload.address));
}

// function getData(file) {
//   return new Promise((resolve) => {
//     var reader = new FileReader();
//
//     reader.onload = function () {
//       resolve(reader.result);
//     }
//
//     reader.readAsBinaryString(file);
//   });
// }

// function* watchSaveCustomerLogoSaga() {
//   yield takeLatest(saveCustomerRoutine.SUCCESS, saveSaga(saveCustomerLogoRoutine, (payload) => {
//     return getAccountPath(`customers/${payload.response.data.id}/logo`);
//   }, () => postBinary, (payload) => {
//     return payload.request.values.get('logo');
//   }, {
//     request: { headers: { 'content-type': 'image/png' } },
//     condition: (payload) => payload.request.values.get('logo').data,
//   }));
// }

export {
  watchFetchCustomersSaga,
  watchFetchCustomerSaga,
  watchSaveCustomerSaga,
  watchRemoveCustomerSaga,

  watchSaveCustomerAddressSaga,
  // watchSaveCustomerLogoSaga,
};



// WEBPACK FOOTER //
// ./src/redux/sagas/customers.js